import { CookSubscriptionSlotMappingInterface } from "../interfaces/CookSubscriptionSlotMappingInterface/CookSubscriptionSlotMappingInterface";
import { CreateCookSubscriptionSlotMappingInterface } from "../interfaces/CookSubscriptionSlotMappingInterface/CreateCookSubscriptionSlotMappingInterface";
import BaseService from "./BaseService";

export class CookSubscriptionSlotMappingService extends BaseService<CookSubscriptionSlotMappingInterface, CreateCookSubscriptionSlotMappingInterface>{ 
    constructor(){
        let url: string = '/cook-subscription-slot-mapping/admin'
        super(url)
    }
}